<template>
  <oceano-default-section :section="section" :menu="menu"
                          class="menu--section-oceano_ayce"></oceano-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Oceano All-you-can-eat menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2023, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-10-05 (1.0.0) (jhoward)
 *      - <OceanoAyceSection> adds an All-You-Can-Eat layout for Oceano menu sections.
 */

import {defineComponent, PropType} from "vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'OceanoAyceSection',
  components: {OceanoDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style>
.oceano_menu--rules {
  text-align: center;
}

.oceano_menu--ayce_includes {
  text-align: center;
  margin-top: 3em;
  border: 0.125em solid #000000;
  padding: 1em;
}

.oceano_menu--rules h3,
.oceano_menu--ayce_includes h3 {
  font-size: 1.6em;
  font-family: serif;
}

.oceano_menu--rules p {
  margin-top: 1.8em;
  font-style: italic;
}

.oceano_menu--ayce_includes p {
  margin-top: 1em;
  font-style: italic;
}
</style>

<style scoped>
.visual_menu--container-landscape .menu--section-oceano_ayce,
html .menu--section.menu--section-oceano_ayce {
  max-width: 564px;
}

.menu--section.menu--section-oceano_ayce {
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
}
</style>